import { notify } from "../../functions/function";
export const dispatchUpdateTime = (
  dispatch,
  clockInTime,
  clockOutTime,
  timesheets,
  id
) => {
  dispatch({
    type: "UPDATE_PLACEMENT_TIME",
    updatePlacementTime: [
      ...timesheets.map((p) => {
        if (p.id === id) {
          p.timesheet.clock_in_time = clockInTime;
          p.timesheet.clock_out_time = clockOutTime;
        }
        return p;
      }),
    ],
  });
};

export const dispatchManualSubmitTimesheet = (
  dispatch,
  clockInTime,
  clockOutTime,
  pendingPlacements,
  id,
  timesheetObjectToAdd
) => {
  dispatch({
    type: "SUBMIT_MANUAL_TIMESHEET",
    submitManualPlacement: [
      ...pendingPlacements.map((p) => {
        if (p.id === id) {
          if (p.timesheet) {
            p.timesheet.clock_in_time = clockInTime;
            p.timesheet.clock_out_time = clockOutTime;
            p.timesheet.clock_in_latitude = "0.000001";
            p.timesheet.clock_in_longitude = "0.000001";
            p.timesheet.human_readable_location_clock_in = "Manual Submission";
            p.timesheet.human_readable_location_clock_out = "Manual Submission";
          } else {
            if (timesheetObjectToAdd) {
              p.timesheet = timesheetObjectToAdd;
            }
          }
        }
        return p;
      }),
    ],
  });
};

export const dispatchUpdatePendingPlacements = (
  dispatch,
  pendingPlacements,
  id,
  isClient,
  status
) => {
  const tempPendingPlacements = [...pendingPlacements];

  tempPendingPlacements.map((p) => {
    if (p.id === id[0]) {
      if (isClient) {
        p.timesheet.client_approval_status = status;
      } else {
        p.timesheet.approval_status = status;
      }

      if (
        p.timesheet.approval_status !== "Pending" &&
        p.timesheet.client_approval_status !== "Pending"
      ) {
        p.timesheet.is_complete = true;
        notify("Success", "Successfully moved to history.", "success");
      }

      return p;
    }
    return null;
  });

  dispatch({
    type: "UPDATE_PENDING_PLACEMENTS",
    updatePendingPlacements: tempPendingPlacements,
  });
};

export const dispatchBulkUpdatePendingPlacements = (
  dispatch,
  pendingPlacements,
  numSelected,
  selectedTimesheets,
  status,
  isClient
) => {
  const tempPendingPlacements = [...pendingPlacements];

  for (let i = 0; i < numSelected; i++) {
    var currentRow = tempPendingPlacements.filter(
      (x) => x.id === selectedTimesheets[i]
    )[0];

    if (currentRow && isClient) {
      currentRow.timesheet.client_approval_status = status;
      currentRow.timesheet.is_complete =
        currentRow.timesheet.approval_status !== "Pending" ? true : false;
    } else {
      currentRow.timesheet.approval_status = status;
      currentRow.timesheet.is_complete =
        currentRow.timesheet.client_approval_status !== "Pending"
          ? true
          : false;
    }
  }

  if (isClient) {
    if (status === "Approved") {
      notify(
        "Success",
        "The selected timesheets has successfully client approved",
        "success"
      );
    } else {
      notify(
        "Success",
        "The selected timesheets has successfully client declined",
        "success"
      );
    }
  } else {
    if (status === "Approved") {
      notify(
        "Success",
        "The selected timesheets has successfully iStaff approved",
        "success"
      );
    } else {
      notify(
        "Success",
        "The selected timesheets has successfully iStaff declined",
        "success"
      );
    }
  }

  if (currentRow.timesheet.is_complete) {
    notify(
      "Success",
      "The selected timesheets has moved to history.",
      "success"
    );
  }

  dispatch({
    type: "UPDATE_PENDING_PLACEMENTS",
    updatePendingPlacements: tempPendingPlacements,
  });
};
